/* eslint-disable import/no-cycle */
import React from "react";
import { SvgProps } from ".";

export const LinkedIn: React.FC<SvgProps> = ({ fill, height, width }) => (
  <svg
    aria-labelledby="LinkedIn"
    height={height || "40px"}
    viewBox="0 0 35 35"
    version="1.1"
    width={width || "40px"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="linkedin-svg">LinkedIn</title>
    <g
      id="Resource-Center"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Important-links-sidebar"
        transform="translate(-1097.000000, -450.000000)"
        fill={fill || "#252525"}
      >
        <g id="Group-4" transform="translate(1036.000000, 410.000000)">
          <g id="icons" transform="translate(1.000000, 40.000000)">
            <g id="linkedin" transform="translate(60.000000, 0.000000)">
              <path
                d="M17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 Z M22.2720111,13.8570182 C20.3840546,13.8570182 19.200975,14.981909 18.9822544,15.7700905 L18.9822544,15.7700905 L18.9822544,13.9674502 L15.2799111,13.9674502 C15.2922832,14.2155814 15.2982401,15.1071612 15.3002766,16.2918715 L15.3009167,16.8165299 C15.3009858,16.9066236 15.3010367,16.9979576 15.3010704,17.0904042 L15.3010722,17.6574128 C15.3010404,17.7537989 15.3009931,17.8510423 15.3009313,17.9490152 L15.3000066,18.8470225 C15.2997248,19.049425 15.2993957,19.2532138 15.2990265,19.4573675 L15.2978064,20.0699019 C15.292725,22.4143168 15.283315,24.6719185 15.2806384,25.2893826 L15.2801002,25.4122335 C15.2799765,25.4401011 15.2799111,25.4545455 15.2799111,25.4545455 L15.2799111,25.4545455 L18.9822544,25.4545455 L18.9822544,19.2389551 C18.9822544,18.8925017 18.9673416,18.547131 19.0627833,18.3002829 C19.3172946,17.6084588 19.8640961,16.892816 20.8473446,16.892816 C22.1328253,16.892816 22.7174058,17.9538295 22.7174058,19.5096218 L22.7174058,19.5096218 L22.7174058,25.4545455 L26.4545455,25.4545455 L26.4545455,19.0668111 C26.4545455,15.5102504 24.6143099,13.8570182 22.2720111,13.8570182 Z M13.2676815,13.9674502 L9.97195972,13.9674502 L9.97195972,25.4534629 L13.2676815,25.4534629 L13.2676815,13.9674502 Z M11.5586783,8.54545455 C10.3417964,8.54545455 9.54545455,9.4061747 9.54545455,10.5408096 C9.54545455,11.6527084 10.3189301,12.5307513 11.5119516,12.5307513 L11.5119516,12.5307513 L11.535812,12.5307513 C12.774566,12.5307513 13.5460532,11.6494604 13.5460532,10.5375616 C13.5221928,9.40400936 12.774566,8.54545455 11.5586783,8.54545455 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
